// USER LIST
export const VAT_MANAGER_LIST = "VAT_MANAGER_LIST";
export const VAT_MANAGER_LIST_SUCCESS = "VAT_MANAGER_LIST_SUCCESS";
export const VAT_MANAGER_LIST_FAIL = "VAT_MANAGER_LIST_FAIL";
export const VAT_MANAGER_LIST_RESET = "VAT_MANAGER_LIST_RESET";
export const VAT_MANAGER_LIST_COLUMN = "VAT_MANAGER_LIST_COLUMN";

// USER ROLE LIST
export const VAT_MANAGER_ROLE_LIST = "VAT_MANAGER_ROLE_LIST";
export const VAT_MANAGER_ROLE_LIST_SUCCESS = "VAT_MANAGER_ROLE_LIST_SUCCESS";
export const VAT_MANAGER_ROLE_LIST_FAIL = "VAT_MANAGER_ROLE_LIST_FAIL";
export const VAT_MANAGER_ROLE_LIST_RESET = "VAT_MANAGER_ROLE_LIST_RESET";
export const VAT_MANAGER_ROLE_LIST_COLUMN = "VAT_MANAGER_ROLE_LIST_COLUMN";

// USER CREATE
export const VAT_MANAGER_CREATE = "VAT_MANAGER_CREATE";
export const VAT_MANAGER_CREATE_SUCCESS = "VAT_MANAGER_CREATE_SUCCESS";
export const VAT_MANAGER_CREATE_FAIL = "VAT_MANAGER_CREATE_FAIL";
export const VAT_MANAGER_CREATE_RESET = "VAT_MANAGER_CREATE_RESET";

// USER DETAIL
export const VAT_MANAGER_DETAIL = "VAT_MANAGER_DETAIL";
export const VAT_MANAGER_DETAIL_SUCCESS = "VAT_MANAGER_DETAIL_SUCCESS";
export const VAT_MANAGER_DETAIL_FAIL = "VAT_MANAGER_DETAIL_FAIL";
export const VAT_MANAGER_DETAIL_RESET = "VAT_MANAGER_DETAIL_RESET";

// USER UPDATE
export const VAT_MANAGER_UPDATE = "VAT_MANAGER_UPDATE";
export const VAT_MANAGER_UPDATE_SUCCESS = "VAT_MANAGER_UPDATE_SUCCESS";
export const VAT_MANAGER_UPDATE_FAIL = "VAT_MANAGER_UPDATE_FAIL";
export const VAT_MANAGER_UPDATE_RESET = "VAT_MANAGER_UPDATE_RESET";

// USER DELETE
export const VAT_MANAGER_DELETE = "VAT_MANAGER_DELETE";
export const VAT_MANAGER_DELETE_SUCCESS = "VAT_MANAGER_DELETE_SUCCESS";
export const VAT_MANAGER_DELETE_FAIL = "VAT_MANAGER_DELETE_FAIL";
export const VAT_MANAGER_DELETE_RESET = "VAT_MANAGER_DELETE_RESET";

// USER ACTIVE
export const VAT_MANAGER_ACTIVE = "VAT_MANAGER_ACTIVE";
export const VAT_MANAGER_ACTIVE_SUCCESS = "VAT_MANAGER_ACTIVE_SUCCESS";
export const VAT_MANAGER_ACTIVE_FAIL = "VAT_MANAGER_ACTIVE_FAIL";
export const VAT_MANAGER_ACTIVE_RESET = "VAT_MANAGER_ACTIVE_RESET";
